import View from './View'
import MotionCount from './MotionCount'

const STATE_INIT = 'loader--init'
const STATE_INTRO = 'loader--intro'
const STATE_OUTRO = 'loader--outro'

/**
 * class Loader
 */
class Loader extends View {
  /**
   * constructor
   */
  constructor (el) {
    super(el)
    this.state = STATE_INIT
    this.count = new MotionCount(this.view, 'loader__count')
  }

  get progress () {
    return this.count.count
  }

  set progress (value) {
    this.count.setCount(value)
  }

  set motionData (value) {
    this.count.motionData = value
  }

  get motionData () {
    return this.count.motionData
  }

  update () {
    this.count.update(...arguments)
  }

  showHandler (resolve) {
    this.state = STATE_INTRO
    resolve()
  }

  hideHandler (resolve) {
    const hide = () => {
      this.state = STATE_OUTRO
      resolve()
    }
    setTimeout(hide, 3000)
  }
}
export default Loader


// WEBPACK FOOTER //
// ./src/scripts/Loader.js